<template>
<main class="content-body">
  <header class="page-header">
    <h2>Zone A</h2>
  </header>
  <div class="row">
    <div class="col-md-12 col-lg-12 col-xl-12">
      <section class="panel">
            <header class="panel-heading">
              <h2 class="panel-title">Création de billet</h2>
            </header>
            <div class="panel-body">
              <div class="row" style='margin-top:25px'>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label">Type * </label>
                    <select v-model="ticket_type_key" class="form-control" v-on:change="loadStatus">
                      <option v-for="option in ticket_type_option" :value="option.ticket_type_key" :key="option.ticket_type_key">
                        {{ option.name }}
                      </option>
                    </select>
                    <label class="error" v-if="errors.ticket_type">{{ errors.ticket_type }}</label>
                  </div>
                </div>
              </div>

              <div class="row" style='margin-top:25px' v-show="showStatus">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label">Statut *</label>
                    <select v-model="status" class="form-control">
                      <option v-for="option in status_option" v-bind:value="option.status_id" v-bind:key="option.status_id" >
                        {{ option.status_name}}
                      </option>
                    </select>
                    <label class="error" v-if="errors.status">{{ errors.status }}</label>
                  </div>
                </div>
              </div>

              <div class="row" style='margin-top:25px'>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label">Responsable * </label>
                    <select v-model="responsable" class="form-control" >
                      <option v-for="option in responsable_option" v-bind:value="option.user_id" v-bind:key="option.user_id">
                        {{ option.responsable_name }}
                      </option>
                    </select>
                    <label class="error" v-if="errors.responsable">{{ errors.responsable }}</label>
                  </div>
                </div>
              </div>

              <div class="row" style='margin-top:25px'>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label">Fournisseur </label>
                    <select v-model="service_provider_id" class="form-control" >
                      <option v-for="option in service_provider_option" v-bind:value="option.service_provider_id" v-bind:key="option.service_provider_id">
                        {{ option.service_provider_name }}
                      </option>
                    </select>
                    <label class="error" v-if="errors.service_provider_id">{{ errors.service_provider_id }}</label>
                  </div>
                </div>
              </div>

              <!-- Exigence -->
              <div class="row" style='margin-top:25px'>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label">Exigence</label>
                    <select v-model="requirement" class="form-control" >
                      <option v-for="option in requirement_option" v-bind:value="option.requirement_id" v-bind:key="option.requirement_id">
                        {{ option.name }}
                      </option>
                    </select>

                  </div>
                </div>
              </div>
              <div class="row" style='margin-top:25px' v-show="showEffectiveDate">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label">Date </label>
                    <datepicker :format="format" :language="fr" :value="effectiveAt" @input="effectiveAt = $event" input-class="form-control"></datepicker>
                  </div>
                </div>
              </div>
              <div class="row" style='margin-top:25px' v-show="showDueDate">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label">Date Butoir</label>
                    <div>
                      <datepicker :format="format" :language="fr" :clear-button="true" :value="dueDate" @input="dueDate = $event" input-class="form-control" wrapper-class="due-date-picker"></datepicker> 
                      <template v-if="isPassedDueDate">
                        <small class="text-muted">La date est dépassée</small>
                      </template>
                      <template v-if="isSoonDue">
                        <small class="text-muted">Bientôt à échéance</small>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style='margin-top:25px' v-show="showPriority">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label">Priorité</label>
                    <priority-pulldown v-model="priority"></priority-pulldown>
                  </div>
                </div>
              </div>
              <div class="row" style='margin-top:25px'>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Titre descriptif * </label>
                    <input v-model="title" type="text" class="form-control" >
                    <label class="error" v-if="errors.title">{{ errors.title }}</label>
                  </div>
                </div>
              </div>
              <div class="row" style='margin-top:25px'>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Description * </label>
                    <trumbowyg
                      :config="$trumbowygConfig"
                      class="form-control"
                      id="textarea"
                      v-model="description"
                      rows="5"
                      max-rows="6">
                    </trumbowyg>
                    <label class="error" v-if="errors.description">{{ errors.description }}</label>
                  </div>
                </div>
              </div>
            </div>
            <footer class="panel-footer">
              <div class="row">
                <div class="col-sm-12">
                  <button class="btn btn-primary" v-on:click="save">Enregistrer</button>&nbsp;
                  <button class="btn btn-default" v-on:click="back" >Retour</button>
                </div>
              </div>
            </footer>
          </section>
        </div>
      </div>
    </main>
</template>

<style>
.due-date-picker {
  display: inline-block;
  width: 10em;
  margin-right: 1em;
}
</style>


<script>

import axios from 'axios';
import Datepicker from 'vuejs-datepicker'
import PriorityPulldown from '../components/PriorityPulldown.vue'
import {en, fr} from 'vuejs-datepicker/dist/locale'


export default {
  data: function() {return {
    ticket_id:0,
    keyword:'',
    ticket_type_key:'',
    responsable:'',
    requirement:'',
    status: null,
    service_provider_id:'',
    ticket_type_option: {},
    responsable_option: {},
    requirement_option: [],
    service_provider_option: {},
    status_option: [],
    effective_at: null,
    due_date: null,
    title:'',
    description:'',
    showStatus:false,
    showEffectiveDate:false,
    showDueDate:false,
    showPriority:false,
    priority: 2,
    errors:{ticket_type:'',status:'',responsable:'',service_provider_id:'',title:'',description:''},
    format:'yyyy-MM-dd',
    en: en,
    fr: fr,
  }},

  name: 'TicketCreation',
  components: {
    Datepicker,
    PriorityPulldown
  },
  computed: {
    isPassedDueDate() {
      return this.moment.utc(this.due_date).isBefore(this.moment().subtract(1, 'days'))
    },
    isSoonDue() {
      return !this.isPassedDueDate && this.moment.utc(this.due_date).isBefore(this.moment().add(5, 'days'))
    },
    dueDate: {
      get() {
        if (!this.due_date) { return }
        return this.parseDate(this.due_date)
      },
      set(newVal) {
        this.due_date = this.fixDate(newVal)
      }
    },
    effectiveAt: {
      get() {
        if (!this.effective_at) { return }
        return this.parseDate(this.effective_at)
      },
      set(newVal) {
        this.effective_at = this.fixDate(newVal)
      }
    }
  },
  methods: {

    loadFilters: function() {
      axios
        .get(this.$root.$data.server_base + '/api/ticket_creation_dropdown.php',
          { })
        .then(response => (
          this.ticket_type_option = response.data.ticket_type,
          this.responsable_option = response.data.responsable,
          this.service_provider_option = response.data.service_provider,
          this.requirement_option = response.data.requirement))
    },


    loadStatus: function()
    {
      axios
        .get(this.$root.$data.server_base + '/api/ticket_creation_dropdown_status.php',
          { params:{ticket_type_key:this.ticket_type_key}})
        .then(response => (
          this.status_option = response.data.ticket_status,
          this.status=response.data.default_status,
          this.showStatus=true,
          this.showEffectiveDate=response.data.showEffectiveDate,
          this.showDueDate=response.data.showDueDate,
          this.showPriority=response.data.showPriority))
    },

    back: function()
    {
      this.$router.go(-1);
    },
    save: function()
    {
      var empty_field = false;

      if(this.ticket_type_key == '')
      {
        this.errors.ticket_type = this.$messages.required;
        empty_field = true;
      }
      else
        this.errors.ticket_type = '';

      if(this.status == null)
      {
        this.errors.status = this.$messages.required;
        empty_field = true;
      }
      else
        this.errors.status = '';

      if(this.responsable == '')
      {
        this.errors.responsable = this.$messages.required;
        empty_field = true;
      }
      else
        this.errors.responsable = '';


      if(this.title == '')
      {
        this.errors.title = this.$messages.required;
        empty_field = true;
      }
      else
        this.errors.title = '';

      if(this.description == '')
      {
        this.errors.description = this.$messages.required;
        empty_field = true;
      }
      else
        this.errors.description = '';

      if(!empty_field)
      {
        
        let data = {
          ticket_type_key:this.ticket_type_key,
          ticket_status:this.status,
          responsable:this.responsable,
          service_provider_id:this.service_provider_id,
          requirement_master_id:this.requirement,
          title:this.title,
          description:this.description,
          effective_at:this.effective_at,
          due_date:this.due_date,
          priority:this.showPriority? this.priority : null
        };

        axios
          .post(this.$root.$data.server_base + '/api/ticket_save.php',
            data,
            {headers:{
                'Content-Type': 'application/json',
            }})
          .then(() => {
            this.$router.go(-1);
          })
      }
    },
    fixDate(event) {
      if (event === null) { return null }
      return this.moment(event).format('YYYY-MM-DD');
    },
    parseDate(dateStr) {
      const [year, month, date] = dateStr.substring(0, 10).split('-')
      if (year === undefined || month === undefined || date === undefined ) { return null }
      if (Number(year) === 0 || Number(month) === 0 || Number(date) === 0 ) { return null }
      return new Date(year, month - 1, date)
    },

  },
  mounted () {
    this.loadFilters();
  }
}

</script>
